import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type InitialStateTypes = {
  recentlyCreated: boolean;
};

const initialState = {
  recentlyCreated: true,
} as InitialStateTypes;

export const referralCodeSlice = createSlice({
  name: "referralCodeSlice",
  reducers: {
    setRecentlyCreated: (state, action: PayloadAction<boolean>) => {
      state.recentlyCreated = action.payload;
    },
  },
  initialState,
});

export const { setRecentlyCreated } = referralCodeSlice.actions;
export default referralCodeSlice.reducer;
